import { Table } from '../../../../../common/table'
import { TBodyCustom } from './TBodyCustom'

export const TableIndustryAnalysis = ({ dataTable, isDynamicReport }) => {
  const {
    ids,
    selectData,
    selectRowGroup,
    selectCellData,
    headers,
    activeRowGroupId,
    changeActiveRow,
  } = dataTable

  return (
    <Table
      ids={ids}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectData}
      schema={headers}
      renderTBody={() => {
        return (
          <TBodyCustom
            ids={ids}
            selectCellData={selectCellData}
            selectRowGroup={selectRowGroup}
            activeRowGroupId={activeRowGroupId}
            changeActiveRow={changeActiveRow}
            schema={headers}
            isDynamicReport={isDynamicReport}
          />
        )
      }}
    />
  )
}
